export function getLiteralsUserPage(t: any) {
    return {
        title: t("loginPage.title"),
        desc: t("loginPage.desc"),
        message: { maintext: t("loginPage.message.maintext") },
        inputmail: { maintext: t("loginPage.inputmail.maintext") },
        inputpass: { maintext: { maintext: t("loginPage.inputpass.maintext.maintext") } },
        button1: t("loginPage.button1"),
        button2: t("loginPage.button2")
    };
}
export function getLiteralsConfirmMailPage(t: any) {
    return {
        title: t("confirmMailPage.title"),
        changeEmail: t("confirmMailPage.changeEmail"),
        desc1: t("confirmMailPage.desc1"),
        desc2: t("confirmMailPage.desc2"),
        confirmmail1: t("confirmMailPage.confirmmail1"),
        confirmmail2: t("confirmMailPage.confirmmail2"),
        buttonmail: {
            openYourMail: t("confirmMailPage.buttonmail.openYourMail"),
            verifyYourAccount: t("confirmMailPage.buttonmail.verifyYourAccount")
        },
        verificationCodeText: t("confirmMailPage.verificationCodeText")
    }
}